import { DevicesServiceClient } from '@pushwoosh/rpc-service-client/pushwoosh/devices/DevicesServiceClientPb';
import {
  SetTagsRequest,
  SetTagsResponse,
} from '@pushwoosh/rpc-service-client/pushwoosh/devices/devices_pb';

export type DevicesExportClasses = {
  DevicesServiceClient: typeof DevicesServiceClient;
  SetTagsRequest: typeof SetTagsRequest;
  SetTagsResponse: typeof SetTagsResponse;
};

export const devices: DevicesExportClasses = {
  DevicesServiceClient,
  SetTagsRequest,
  SetTagsResponse,
};
